import { DialogAgregarMaterialComponent } from './dialog-agregar-material.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { ModalPedidoItemDto, MaterialDto, PedidoItemDto, RubroContable,  SearchMaterialRequest, SearchRubroContableRequest, UnidadMedidaDto,MenuFuncionCodes } from '../../../../../src/app/shared/model';
import { RubroContableService, MenuFuncionService, PedidoService } from '../../../../../src/app/shared/services';
import { MaterialesService } from '../../../../../src/app/shared/services/materiales.service';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

@Component({
  selector: 'app-dialogModificarPedidoItem',
  templateUrl: 'dialogModificarPedidoItem.component.html',
  styleUrls: ['./dialogModificarPedidoItem.component.scss']
})

export class DialogModificarPedidoItemComponent implements OnInit {

  public title: string;
  public buttonAcceptText: string;
  public buttonCancelText: string;

  isMaterialSearching: boolean = false;
  isUnidadMedidaSearching: boolean = false;
  isMaterialAutoSearching: boolean = false;
  isRubroContableSearching: boolean = false;
  isEmpleadoSaving: boolean = false;
  isDeleting: boolean = false;
  isSaving: boolean = false;
  isLoading: boolean = false;
  isValidating: boolean = false;
  isPedidoItemEdit: boolean = false;
  isSavingMaterial:boolean = false;

  canCreateNewMaterial: boolean = false;
  newMaterial:boolean = false;

  formGroup: FormGroup;
  formGroupNuevoMaterial : FormGroup;

  pedidoItem: PedidoItemDto;

  materialList: MaterialDto[] = [];
  filteredMaterialList: MaterialDto[] = [];
  rubroContableList: RubroContable[] = [];
  unidadMedidaList:UnidadMedidaDto[];

  item: MaterialDto;
  itemMaterial: ModalPedidoItemDto;

  necesidadDate: Date = new Date();
  limiteDate: Date = new Date();

  constructor(
    private dialogRef: MatDialogRef<DialogModificarPedidoItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalPedidoItemDto,
    private menuService: MenuFuncionService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private materialService: MaterialesService,
    private sharedFunctions: SharedFunctions,
    private rubroContableService: RubroContableService,
    private pedidoService: PedidoService
  ) {
    this.buildForm();
    this.pedidoItem = this.data?.PedidoItemDto;
  }

  ngOnInit() {
    this.menuService.checkMenu(MenuFuncionCodes.PEDIDO_MATERIAL_LIST).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onDecline();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });

    this.buttonAcceptText = 'Guardar';
    this.buttonCancelText = (this.data.CanEditMaterial ? 'Cancelar' : 'Cerrar');
  }

  async loadView() {
    this.isLoading = true;
    try {
      this.menuService.checkMenu(MenuFuncionCodes.MATERIAL_ADD).subscribe(data => {
        if (data != null && data.Success && data?.Result) {
          this.canCreateNewMaterial = true;
        }
      },
      (err: HttpErrorResponse) => {
        this.sharedFunctions.handleError(err, true);
        this.isLoading = false;
      });

      // this.getRubroContableAutocomplete();
      await this.getRubroContable();
      this.getMaterialesAutocomplete();
      this.loadEntity();
      this.isLoading = false;
    }
    catch (error) {
      this.sharedFunctions.handleError(error, true);
      this.isLoading = false;
    }
  }

  loadEntity() {
    this.isPedidoItemEdit = (this.data.PedidoId > 0);

    if (this.data.PedidoItemDto != null) {
      if (this.data.PedidoItemDto.MaterialId != null && this.data.PedidoItemDto.MaterialId > 0)
      this.filteredMaterialList = [new MaterialDto(this.data.PedidoItemDto.MaterialId, this.data.PedidoItemDto.MaterialNombre, null, null, null, null, null, true)];

      this.formGroup.patchValue({
        ...this.data.PedidoItemDto,
        RubroContable: this.rubroContableList?.find(x => x.Id == this.data?.PedidoItemDto?.RubroContableId),
        Material: (this.filteredMaterialList != null && this.filteredMaterialList.length > 0 ? this.filteredMaterialList[0] : null)
      });
    }
    else {
      this.item = new MaterialDto(null, null, null, null, this.data.TipoMaterialId, this.data.TipoMaterialNombre, null, true);
      this.formGroup.patchValue(this.item);
    }
  }

  checkToday() {
    if (this.formGroup.controls.FechaNecesidad.value < new Date()) {
      this.sharedFunctions.showMessage("La fecha de necesidad debe ser mayor a la fecha actual", "Error");
      this.formGroup.controls.FechaNecesidad.setValue(this.necesidadDate);
      return false;
    }
    return true;
  }

  checkDate() {
    if(this.formGroup.controls.FechaNecesidad.value > this.formGroup.controls.FechaLimite.value || this.formGroup.controls.FechaLimite.value < new Date() ){
      this.sharedFunctions.showMessage("La fecha límite no puede ser menor a la fecha de necesidad", "Error");
      this.formGroup.controls.FechaLimite.setValue(this.formGroup.controls.FechaNecesidad.value);
      return false;
    }
    return true;
  }

  isProcessing() {
    return (this.isSaving || this.isDeleting);
  }

  displayMaterial(material: MaterialDto): string {
    return material && material?.Nombre ? material.Nombre : '';
  }

  // displayRubroContable(rubroContable: RubroContable): string {
  //   return rubroContable && rubroContable?.Nombre ? rubroContable.Codigo + '. ' + rubroContable.Nombre : '';
  // }

  getMaterialWidth() {
    return (this.canCreateNewMaterial ? 90 : 100);
  }

//#region forms

  buildForm() {
    this.necesidadDate.setDate((new Date()).getDate() + 10);
    this.limiteDate.setDate((new Date()).getDate() + 13);
    this.formGroup = this.formBuilder.group({
      'Id': [0],
      'Material': [null, Validators.required],
      'Cantidad': [null, Validators.required],
      'FechaNecesidad': [this.necesidadDate, [Validators.required]],
      'FechaLimite': [this.limiteDate, [Validators.required]],
      'RubroContable': [null,  Validators.required],
      'Detalle': [null],
      'Observacion': [null]
    });
  }

//#endregion

//#region autocomplete

  getMaterialesAutocomplete() {
    this.formGroup.get('Material')?.valueChanges
    .pipe(
      filter(res => {
        return res && res !== null && res.length >= 3
      }),
      distinctUntilChanged(),
      debounceTime(1000),
      tap(() => {
        this.filteredMaterialList = [];
        this.isMaterialAutoSearching = true;
      }),
      switchMap(value => this.materialService.search(new SearchMaterialRequest(null, null, null, null, value,null,this.data.TipoMaterialId, true))
        .pipe(
          finalize(() => {
            this.isMaterialAutoSearching = false;
          }),
        )
      )
    )
    .subscribe((data: any) => {
      if (data != null && data.result != null){
        this.filteredMaterialList = data.result;
      }
      else
        this.filteredMaterialList = [];
    });
  }

  // getRubroContableAutocomplete() {
  //   this.formGroup.get('RubroContable')?.valueChanges
  //   .pipe(
  //     filter(res => {
  //       return res && res !== null && res.length >= 2
  //     }),
  //     distinctUntilChanged(),
  //     debounceTime(1000),
  //     tap(() => {
  //       this.rubroContableList = [];
  //       this.isRubroContableSearching = true;
  //     }),
  //     switchMap(value => isNaN(value) ? this.rubroContableService.search(new SearchRubroContableRequest(null, null, null, null, value, null, true)) :
  //                                       this.rubroContableService.search(new SearchRubroContableRequest(null, null, null, null, null, value, true))
  //       .pipe(
  //         finalize(() => {
  //           this.isRubroContableSearching = false;
  //         }),
  //       )
  //     )
  //   )
  //   .subscribe((data: any) => {
  //     if (data != null && data.result != null)
  //       this.rubroContableList = data.result;
  //     else
  //       this.rubroContableList = [];
  //   });
  // }

  // getRubroContable(){
  //   this.rubroContableService.search(new SearchRubroContableRequest(null, null, null, null, null, null, true)).subscribe((data: any) => {
  //     if (data != null && data.result != null){
  //         const rubroContableSelected = this.rubroContableList[0];
  //         this.rubroContableList = data.result;
  //         if(rubroContableSelected){
  //           this.rubroContableList.unshift(rubroContableSelected);
  //         }

  //     }
  //     else
  //       this.rubroContableList = [];
  //   });
  // }

  async getRubroContable(){
    this.isRubroContableSearching = true;
    try {
      const data = await this.rubroContableService.search(new SearchRubroContableRequest(null, null, null, null, null, null, true)).toPromise();
      this.isRubroContableSearching = false;
      if (data != null && data.result != null){
        this.rubroContableList = data.result.sort((a, b) => {
          const codigoA = parseInt(a.Codigo, 10);
          const codigoB = parseInt(b.Codigo, 10);
          return codigoA - codigoB;
        });
        // this.rubroContableList = data.result;

      } else {
        this.rubroContableList = [];
      }
    } catch (error) {
      this.sharedFunctions.handleError(error, true);
      this.isRubroContableSearching = false;

    }
  }

  // onSelectRubroContable(){
  //    this.formGroup.get('RubroContable')?.setValue(this.formGroup.get('RubroContable')?.value);
  // }

//#endregion

//#region actions

  onGuardar() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    if (!this.filteredMaterialList.find(x => x.Id == this.formGroup.controls['Material'].value?.Id)) {
      this.sharedFunctions.showMessage("Debe seleccionar un material de la lista de materiales", "Error");
      return false;
    }

    if (!this.checkToday())
      return;
    if (!this.checkDate())
      return;

    const material = this.formGroup.controls['Material'].value;

    const pedidoItem: PedidoItemDto = {
      ...this.formGroup.value,
      ... {
        Id: this.data.PedidoItemDto?.Id ?? 0,
        PedidoId: this.data.PedidoId,
        MaterialId: material?.Id,
        MaterialNombre: material?.Nombre,
        MaterialUnidadMedida: material?.UnidadMedida?.Abreviatura,
        RubroContableId: this.formGroup.value.RubroContable?.Id,
        RubroContableNombre: this.formGroup.value.RubroContable?.Nombre,
        TipoMaterialId: this.data?.TipoMaterialId,
        TipoMaterialNombre: this.data?.TipoMaterialNombre,
        Activo: true
      }
    };

    if (this.isPedidoItemEdit) {
      this.isSavingMaterial = true;
      this.pedidoService.savePedidoItem(pedidoItem).subscribe((data) => {
        this.isSavingMaterial = false;
        if (data?.Success && data.Result?.PedidoId > 0) {
          this.sharedFunctions.showMessage("Se guardó correctamente el material!", "Operación Exitosa!");
          this.dialogRef.close(data.Result);
        }
        else {
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        }
      },
      (err: HttpErrorResponse) => {
        this.isSavingMaterial = false;
        this.sharedFunctions.handleError(err, true);
        // this.dialogRef.close(null);
      });
    }
    else {
      this.dialogRef.close(pedidoItem);
    }
  }

  onDecline() {
    this.dialogRef.close(null);
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
          this.formGroup.get(formFieldName)?.setValue(null);
    }
  }

  addNewMaterial() {
    if (!this.canCreateNewMaterial)
      return false;
    var addNewMaterial = new MaterialDto(null,null,null,null,this.data.TipoMaterialId,this.data.TipoMaterialNombre,null,true);
    const dialogRef = this.dialog.open(DialogAgregarMaterialComponent, {
      width: '600px',
      data: addNewMaterial
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result != null && result.Id > 0) {
        this.formGroup.get("Material")?.setValue(result);
        this.formGroup.get("MaterialId")?.setValue(result?.Id);
      }
    });
  }

//#endregion

//#region gerErrors messages

  getErrorDescripcion() {
    var v = this.formGroup.get('Descripcion');
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorCantidad() {
    var v = this.formGroup.get('Cantidad');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorFechaNecesidad() {
    var v = this.formGroup.get('FechaNecesidad');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorFechaLimite() {
    var v = this.formGroup.get('FechaLimite');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorObservacion() {
    var v = this.formGroup.get('Observacion');
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorMaterial() {

    if(this.formGroup.get('Material')?.hasError('required')){
      return 'El campo es obligatorio';
    }
    if(this.formGroup.get('Material')?.invalid && this.formGroup.get('Material')?.dirty){
      return 'Debe seleccionar un Material de la lista';
    }
    return '';

  }

  getErrorRubroContable() {
    return this.formGroup.get('RubroContable')?.hasError('required') ? 'El campo es obligatorio' :'';
  }
//#endregion
}
